import React from "react";
import SettingTemplate from "../small-components/SettingTemplate/SettingTemplate";
import DuplicateTemplate from "../small-components/DuplicateTemplate/duplicate-template";
import DeleteTemplate from "../small-components/DeleteTemplates";
import SaveTemplate from "../small-components/SaveTemplate/SaveTemplate";
import ShareTemplate from "../small-components/ShareTemplates";

export default function EstimaticSetting(props) {
  const { key } = props;
  return (
    <section className="estimates-settings">
      <div className="container">
        <SettingTemplate click={props.click} dataKey={key} />
        <DuplicateTemplate click={props.click} dataKey={key} />
        <DeleteTemplate click={props.click} dataKey={key} />
        <SaveTemplate click={props.click} dataKey={key} />
        <ShareTemplate click={props.click} dataKey={key} />
      </div>
    </section>
  );
}
